import React, { FC, useContext } from 'react';
import { find, times } from 'lodash';
import { addWeeks, isAfter, parseISO } from 'date-fns';
import { ThemeContext } from 'styled-components';
import { Box, Text, Theme, useMediaQuery, belowBreakpoint } from '@bechtel/gds';
import { MilestoneStatusCode } from '@bechtel/types';
import { TabListStyled, TabButtonStyled } from './styled';
import { TabFilterProps } from './types';
import { useDate } from '@bechtel/client-common';
import { WeekStartType } from '~/types';
import { t, Trans } from '@lingui/macro';

export const TabFilters: FC<TabFilterProps> = ({ user, tabFilterValues, onTabFilterChange, loading, workSummary }) => {
  const { getWeekNo } = useDate();
  const { breakpoints } = useContext<Theme>(ThemeContext);
  const isWideScreen = useMediaQuery(belowBreakpoint(breakpoints.widescreen));
  const currentProjectWeek = find(user?.project?.projectConfiguration?.projectWeeks, (projectWeek) =>
    projectWeek?.isCurrent ? true : false
  );
  const weekStartsOn: WeekStartType = (user?.project?.projectConfiguration.weekStartDay
    ? user?.project?.projectConfiguration.weekStartDay
    : 1) as WeekStartType; // Default start day is monday
  const currentWeekStartDate = parseISO(currentProjectWeek?.startDate); //parseIso is required since weekStartDate is date(NOT datetime) string
  const selectedWeekStartDate = tabFilterValues?.weekStartDay
    ? new Date(tabFilterValues?.weekStartDay)
    : currentWeekStartDate;
  const claimedFilter = tabFilterValues?.milestoneStatus === MilestoneStatusCode.CLAIMED ? true : false;
  const selectedWeek = getWeekNo(selectedWeekStartDate, weekStartsOn);

  return (
    <>
      <TabListStyled>
        {times(4, (index) => {
          return (
            <TabButtonStyled
              selected={selectedWeek === getWeekNo(addWeeks(currentWeekStartDate, index - 1), weekStartsOn)}
              key={index}
              onClick={() => {
                onTabFilterChange({
                  weekStartDay: addWeeks(currentWeekStartDate, index - 1),
                  milestoneStatus: MilestoneStatusCode.PLANNED,
                });
              }}
            >
              <Box flexDirection={{ sm: 'column' }}>
                <Text size={isWideScreen ? '200' : '300'} color="blue.700">
                  <Trans>Week</Trans>
                </Text>
                <Text size={isWideScreen ? '500' : '600'} color="blue.700">
                  {getWeekNo(addWeeks(currentWeekStartDate, index - 1), weekStartsOn) || 0}
                </Text>
              </Box>
            </TabButtonStyled>
          );
        })}
      </TabListStyled>
      <TabListStyled>
        <TabButtonStyled
          selected={!claimedFilter}
          onClick={() => {
            onTabFilterChange({
              weekStartDay: selectedWeekStartDate,
              milestoneStatus: MilestoneStatusCode.PLANNED,
            });
          }}
        >
          <Box flexDirection={{ sm: 'column' }}>
            <Text size="400" color="grey.1000">
              <Trans>Unclaimed</Trans>&nbsp;{!loading && `(${workSummary?.unclaimedHours} ` + t`hrs` + `)`}
            </Text>
          </Box>
        </TabButtonStyled>
        <TabButtonStyled
          selected={claimedFilter}
          onClick={() => {
            onTabFilterChange({
              weekStartDay: selectedWeekStartDate,
              milestoneStatus: MilestoneStatusCode.CLAIMED,
            });
          }}
          disabled={isAfter(selectedWeekStartDate, currentWeekStartDate)}
        >
          <Box flexDirection={{ sm: 'column' }}>
            <Text size="400" color="grey.1000">
              <Trans>Claimed</Trans>&nbsp;{!loading && `(${workSummary?.claimedHours} ` + t`hrs` + `)`}
            </Text>
          </Box>
        </TabButtonStyled>
      </TabListStyled>
    </>
  );
};
